<div #notesContainer class="notes-container">
  <header class="notes-header">
    <span class="notes-count">
      @if (isNotesLoaded && notes?.length) {
        {{ 'detailsNote.count' | translate: { count: notes.length } }}
      }
    </span>
    <button
      type="button"
      class="notes-follow"
      data-cy="notes-panel-follow-button"
      [class.active]="isFollow"
      [attr.aria-pressed]="isFollow"
      [title]="'detailsNote.' + (isFollow ? 'un' : '') + 'follow' | translate"
      (click)="follow(!isFollow)">
      <i aria-hidden="true" [class]="isFollow ? 'icon-bell' : 'icon-bell-slash'"></i>
      <span>{{ (isFollow ? 'detailsNote.following' : 'detailsNote.followShort') | translate }}</span>
    </button>
  </header>

  <div #notesWrapper class="notes-wrapper" role="list" aria-live="polite" [attr.aria-busy]="!isNotesLoaded">
    @if (!isNotesLoaded) {
      <div class="notes-skeleton" aria-hidden="true">
        @for (i of [1, 2, 3]; track i) {
          <div class="notes-skeleton-row" [class.right]="i === 2">
            <span class="notes-skeleton-avatar"></span>
            <span class="notes-skeleton-bubble"></span>
          </div>
        }
      </div>
      <span class="notes-sr-only">{{ 'detailsNote.loading' | translate }}</span>
    } @else if (notes.length === 0) {
      <div class="notes-empty" data-cy="notes-panel-empty-container">
        <i aria-hidden="true" class="icon-empty-note icon-notes"></i>
        <p class="notes-empty-title">{{ 'detailsNote.emptyNote' | translate }}</p>
        <p class="notes-empty-hint">{{ 'detailsNote.emptyHint' | translate }}</p>
      </div>
    } @else {
      @for (note of notes; track note.id || $index) {
        @if (note.dayLabel) {
          <div class="notes-day" role="separator">
            <span>{{ note.dayLabel }}</span>
          </div>
        }
        <iu-note-ui [note]="note" [parent]="this" />
      }
    }
  </div>

  <form class="notes-form" data-cy="notes-panel-form" [class.is-sending]="isNoteSending" (submit)="$event.preventDefault()">
    @if (entryAttachment !== null) {
      <div class="notes-attachment" [title]="entryAttachment?.name">
        <i aria-hidden="true" [ngClass]="[entryAttachment?.name | docIcon]"></i>
        <span class="notes-attachment-name">{{ entryAttachment.name }}</span>
        <button
          type="button"
          class="notes-icon-button"
          [attr.aria-label]="'detailsNote.removeAttachment' | translate"
          [title]="'detailsNote.removeAttachment' | translate"
          (click)="deleteEntryAttachment()">
          <i aria-hidden="true" class="icon-close"></i>
        </button>
      </div>
    }

    <div class="notes-composer">
      @if (entryAttachment === null) {
        <button
          type="button"
          class="notes-icon-button"
          data-cy="notes-panel-file-button"
          [attr.aria-label]="'detailsNote.attach' | translate"
          [title]="'detailsNote.attach' | translate"
          [disabled]="isNoteSending"
          (click)="displayJoinFilesPanel = true">
          <i aria-hidden="true" class="icon-attach3x"></i>
        </button>
      }
      <div class="notes-input">
        <iu-input-mention-ui
          #inputMentionRef
          [readonly]="!isTagsLoaded || isNoteSending"
          [sendIcon]="true"
          [sendOnEnter]="true"
          [tags]="tags$"
          (enterEmitter)="sendNote()" />
      </div>
    </div>
    <p class="notes-hint">{{ (isNoteSending ? 'detailsNote.sending' : 'detailsNote.mentionHint') | translate }}</p>
  </form>

  @if (displayJoinFilesPanel) {
    <iu-modal-ui
      [contentType]="ModalContentType.JOINFILES"
      [hasCloseBtn]="true"
      [title]="'joinFiles.title'"
      (closeModalEmitter)="displayJoinFilesPanel = false">
      <iu-join-file-ui
        [adTable_ID]="table_id"
        [dsKey]="currentDataStoreKey"
        [fromNotes]="true"
        (uploadEnd)="fileUpload($event); displayJoinFilesPanel = false" />
    </iu-modal-ui>
  }
</div>
